import { toStorageImageApiSegment } from '../../utils/storageImagePath';

export const EXPECTED_EMBEDDING_DIM = 512;

export const hasValidEncoding = (face) => {
  if (!face?.face_encoding) return false;
  try {
    const parsed = JSON.parse(face.face_encoding);
    return Array.isArray(parsed)
      && parsed.length === EXPECTED_EMBEDDING_DIM
      && parsed.every((value) => typeof value === 'number' && Number.isFinite(value));
  } catch {
    return false;
  }
};

export const formatDateTime = (value) => {
  if (!value) return '—';
  try {
    const date = new Date(value);
    return `${date.toLocaleDateString('pt-BR')} • ${date.toLocaleTimeString('pt-BR')}`;
  } catch {
    return String(value);
  }
};

export const formatDate = (value) => {
  if (!value) return '';
  try {
    return new Date(value).toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  } catch {
    return '';
  }
};

export const getSocketUrl = () => {
  if (process.env.REACT_APP_SOCKET_URL) return process.env.REACT_APP_SOCKET_URL;

  const { protocol, hostname, port, origin } = window.location;
  if (['3000', '3001', '3002'].includes(port)) {
    return `${protocol}//${hostname}:5000`;
  }

  return origin;
};

export const fetchFaceImageWithAuth = async (imageName) => {
  try {
    if (!imageName) return '';
    const actualFilename = (imageName.includes('/') || imageName.includes('\\'))
      ? imageName.split('/').pop().split('\\').pop()
      : imageName;

    const token = localStorage.getItem('token');
    const response = await fetch(`/api/faces/image/${actualFilename}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Erro ao buscar imagem');
    const blob = await response.blob();
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error('Erro ao carregar imagem de rosto:', error);
    return '';
  }
};

export const fetchAlertImageWithAuth = async (imageName) => {
  try {
    if (!imageName) return '';
    const actualFilename = toStorageImageApiSegment(imageName, 'alerts');
    if (!actualFilename) return '';

    const token = localStorage.getItem('token');
    const response = await fetch(`/api/alerts/image/${actualFilename}`, {
      headers: { Authorization: `Bearer ${token}` }
    });
    if (!response.ok) throw new Error('Erro ao buscar imagem');
    const blob = await response.blob();
    return URL.createObjectURL(blob);
  } catch (error) {
    console.error('Erro ao carregar imagem de detecção:', error);
    return '';
  }
};

export const parseDetectionDescription = (description) => {
  if (!description) return {};
  if (typeof description === 'object') return description;
  try {
    return JSON.parse(description);
  } catch {
    return { text: description };
  }
};
